import { z } from "zod/v4";

export const ApiScopesList = [
  "read_experiments",
  "write_experiments",
  "write_test_groups",
  "read_integrations",
] as const;

export type ApiScopesType = (typeof ApiScopesList)[number];

export const ApiDtoSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  description: z.string().nullish(),
  accessToken: z.string(),
  scopes: z.enum(ApiScopesList).array(),
  organization: z.object({
    id: z.uuid(),
    name: z.string(),
  }),
});

export type ApiDto = z.infer<typeof ApiDtoSchema>;

export const ErrorWithMessage = z.object({ error: z.string() });

export const BadRequestHttpErrorSchema = z.record(z.string(), z.any());
